module.exports = __webpack_public_path__ + "b37c6460a1f0e02c2d851ae1bd526dab.mp4";